export default __webpack_public_path__ + "static/media/gasag_m2.88d91753.png";